import { Box, Typography, Container, Link, Grid, Divider } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { Phone as PhoneIcon, Email as EmailIcon, LocationOn as LocationIcon } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        bgcolor: (theme) => theme.palette.mode === 'dark' ? 'grey.900' : 'primary.main', 
        color: 'white', 
        py: 6, 
        mt: 'auto',
        background: (theme) => theme.palette.mode === 'dark'
          ? 'linear-gradient(135deg, #424242 0%, #212121 100%)'
          : 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: 'white' }}>
              PolicyTap
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, opacity: 0.9 }}>
              Your trusted insurance agent and financial advisor in Secunderabad.
              Expert guidance for Term Plans, ULIP, Pension Plans, and comprehensive financial planning.
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600, opacity: 0.9 }}>
              Tata AIA Certified Agent
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: 'white' }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                component={RouterLink}
                to="/"
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.9, '&:hover': { opacity: 1, textDecoration: 'underline' } }}
              >
                Home
              </Link>
              <Link
                component={RouterLink}
                to="/services"
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.9, '&:hover': { opacity: 1, textDecoration: 'underline' } }}
              >
                Services
              </Link>
              <Link
                component={RouterLink}
                to="/contact"
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.9, '&:hover': { opacity: 1, textDecoration: 'underline' } }}
              >
                Contact
              </Link>
              <Link
                component={RouterLink}
                to="/join"
                color="inherit"
                sx={{ textDecoration: 'none', opacity: 0.9, '&:hover': { opacity: 1, textDecoration: 'underline' } }}
              >
                Join Us
              </Link>
            </Box>
          </Grid>

          {/* Services */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: 'white' }}>
              Our Services
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>Term Life Insurance</Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>ULIP Plans</Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>Pension Plans</Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>Protection Plans</Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>Savings Plans</Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>Financial Planning</Typography>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} md={3}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: 'white' }}>
              Contact Info
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon sx={{ fontSize: '1.2rem', opacity: 0.9 }} />
                <Link href="tel:+916281648568" color="inherit" sx={{ textDecoration: 'none', opacity: 0.9, '&:hover': { opacity: 1 } }}>
                  +91 6281648568
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon sx={{ fontSize: '1.2rem', opacity: 0.9 }} />
                <Link href="mailto:contact@policytap.in" color="inherit" sx={{ textDecoration: 'none', opacity: 0.9, '&:hover': { opacity: 1 } }}>
                  contact@policytap.in
                </Link>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <LocationIcon sx={{ fontSize: '1.2rem', opacity: 0.9, mt: 0.2 }} />
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Secunderabad, Telangana, India
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, bgcolor: 'rgba(255,255,255,0.2)' }} />

        {/* Bottom Section */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            © {new Date().getFullYear()} PolicyTap. All rights reserved.
          </Typography>

          <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', alignItems: 'center' }}>
            <Link
              component={RouterLink}
              to="/privacy-policy"
              color="inherit"
              sx={{ textDecoration: 'none', opacity: 0.9, '&:hover': { opacity: 1, textDecoration: 'underline' } }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to="/security"
              color="inherit"
              sx={{ textDecoration: 'none', opacity: 0.9, '&:hover': { opacity: 1, textDecoration: 'underline' } }}
            >
              Security
            </Link>
            <Typography variant="body2" sx={{ opacity: 0.9, display: 'flex', alignItems: 'center', gap: 0.5 }}>
              🔒 SSL Secured
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
